import { theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors, fonts } = theme;

export const price = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  &[data-is-previous-price='true'] {
    color: ${colors.neutralDark};
    text-decoration: line-through;
  }

  &[data-is-sale-price='true'] {
    color: ${colors.redPrimary};
  }
`;
